import { SlidersHorizontal } from 'lucide-react';

import { definePanel } from '@/app/definePanel';

export default definePanel({
    id: 'rule_flow_details',
    title: 'Card settings',
    icon: SlidersHorizontal,
    // As wide as a rule tile; wider shows the whole day of the schedule grid.
    width: { min: 360, default: 400, max: 640, fill: false },
    modes: ['settings'],
    themes: 'any',
    // Right of the flow; the flow fills the row, so it floats over the flow's right part.
    order: 4.6,
    isOverlay: true,
    // It shows the selected card, so it wears that card's surface.
    hasSelectedSurface: true,
    // The panel draws its own header, which names the kind of the card.
    isHeaderless: true,
    // Opened by a click on a card, not by a rail button.
    hasNavButton: false,
    // ruleId and elementId mirror the selection of the flow panel; they stay in the local props.
    urlSyncedProps: [],
});
